import React from 'react';
import { Teaser } from '@ktag/styleguide/dist/react';
import { JobPortalScreen } from 'jobs.types';
import { useTranslation } from 'react-i18next';

interface Props {
  setScreen: (screen: JobPortalScreen) => void;
}

const AboTeaser = ({ setScreen }: Props) => {
  const { t } = useTranslation('jobs');
  return (
    <Teaser
      additionalClassNames="aboteaser"
      highlighted
      title={t('aboteaser_title')}
      description={t('aboteaser_description')}
      cta={t('aboteaser_cta')}
      ctaIconId="email"
      onClick={() => setScreen('jobabo')}
      linkAs="button"
    />
  );
};

export default AboTeaser;
